/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_Dashboard_TitleInputs */

const en_logistics_dashboard_title = /** @type {(inputs: Logistics_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics Dashboard`)
};

const es_logistics_dashboard_title = /** @type {(inputs: Logistics_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de logistica`)
};

/**
* | output |
* | --- |
* | "Logistics Dashboard" |
*
* @param {Logistics_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const logistics_dashboard_title = /** @type {((inputs?: Logistics_Dashboard_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_Dashboard_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_dashboard_title(inputs)
	return es_logistics_dashboard_title(inputs)
});